import Modal from './modal-singleton'

class ModalInit {
  constructor() {
    this.modal = new Modal('modal')
  }
}

export default new ModalInit()
